import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { postData } from "../../utility/Utility";
import CustomLoader from "../../Components/CustomLoader/CustomLoader";
import { toast, ToastContainer } from "react-toastify";

function XOXODashboard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [balanceData, setBalanceData] = useState({
    availableBalance: 0,
    requirementBalance: 0,
    usedBalance: 0,
  });

  const fetchBalanceData = async () => {
    setLoading(true);
    try {
      // For now, we'll simulate balance data
      // In real implementation, this would call a balance API
      const response = await postData("api/xoxoday/vouchers/admin-balance");

      if (response?.success && response?.data?.AvailableBalance !== undefined) {
        setBalanceData({
          availableBalance: response.data.AvailableBalance,
          requirementBalance: 0,
          usedBalance: 0,
        });
      } else {
        // Simulate data for demo
        setBalanceData({
          availableBalance: 0,
          requirementBalance: 0,
          usedBalance: 0,
        });
      }
    } catch (error) {
      console.error("Error fetching balance data:", error);
      toast.error("Error fetching balance data");
      // Set demo data on error
      setBalanceData({
        availableBalance: 0,
        requirementBalance: 0,
        usedBalance: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBalanceData();
  }, []);

  return (
    <div className="content-page">
      <ToastContainer position="top-right" autoClose={3000} />
      <CustomLoader loading={loading} />
      <div className="content">
        <div className="container-fluid">
          <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
            <div className="flex-grow-1">
              <h4 className="fs-18 fw-semibold m-0">XOXO Dashboard</h4>
              <p className="fw-semibold my-2">Balance Overview</p>
            </div>
            <div className="d-flex gap-2">
              <button
                className="btn btn-primary"
                onClick={() => navigate("/xoxo-order-history")}
                disabled={loading}
              >
                <i className="mdi mdi-history me-1"></i>
                Order History
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => navigate("/xoxo-payment-history")}
                disabled={loading}
              >
                <i className="mdi mdi-credit-card me-1"></i>
                Payment History
              </button>
            </div>
          </div>

          <div className="row">
            {/* Available Balance Card */}
            <div className="col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-semibold mb-2">
                        Available Balance
                      </p>
                      <h3 className="mb-0 text-success">
                        ₹{balanceData.availableBalance?.toLocaleString("en-IN")}
                      </h3>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar-sm rounded">
                        <span className="avatar-title bg-success-lighten text-success rounded fs-4">
                          <i className="mdi mdi-cash-multiple"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Requirement Balance Card */}
            <div className="col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-semibold mb-2">
                        Requirement Balance
                      </p>
                      <h3 className="mb-0 text-warning">
                        ₹
                        {balanceData.requirementBalance?.toLocaleString(
                          "en-IN"
                        )}
                      </h3>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar-sm rounded">
                        <span className="avatar-title bg-warning-lighten text-warning rounded fs-4">
                          <i className="mdi mdi-chart-line"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Used Balance Card */}
            <div className="col-md-4">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-semibold mb-2">
                        Used Balance
                      </p>
                      <h3 className="mb-0 text-info">
                        ₹{balanceData.usedBalance?.toLocaleString("en-IN")}
                      </h3>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="avatar-sm rounded">
                        <span className="avatar-title bg-info-lighten text-info rounded fs-4">
                          <i className="mdi mdi-trending-down"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="row mt-4">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title mb-3">Quick Actions</h5>
                  <div className="d-flex gap-3 flex-wrap">
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => navigate("/xoxo-order-history")}
                    >
                      <i className="mdi mdi-history me-2"></i>
                      View Order History
                    </button>
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => navigate("/xoxo-payment-history")}
                    >
                      <i className="mdi mdi-credit-card me-2"></i>
                      View Payment History
                    </button>
                    <button
                      className="btn btn-outline-info"
                      onClick={fetchBalanceData}
                      disabled={loading}
                    >
                      <i className="mdi mdi-refresh me-2"></i>
                      Refresh Balance
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default XOXODashboard;
